module.exports = __webpack_public_path__ + "static/img/company-performance-barometer-hero-lowres.3199329.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/company-performance-barometer-hero-lowres.jpg
// module id = v2ig
// module chunks = 0